const qualityProgram = {
  Title: "Quality you can count on",
  Description:
    "Recognizing that quality supplements start with manufacturing, the Emerson Quality Program\u00A0(EQP)® was designed to provide reliable information about the integrity and efficacy of the brands we carry.",
  List: {
    ListItem1:
      "All of Emerson Ecologics' brands meet federal current Good Manufacturing Practices (cGMPs)",
    ListItem2:
      "Many brands exceed these standards and have been certified as our gold and silver partner brands",
    ListItem3:
      "Quality designations are easily searchable to ensure you find the right products for your practice",
  },
};

export { qualityProgram };
